export default __webpack_public_path__ + "assets/images/e0bfa7872a95639f45ae717f62d86d8f.svg";